import { Tab } from '@revelio/data-access';

import CompanyIcon from './CompanyIcon';
import GeographyIcon from './GeographyIcon';
import IndividualIcon from './IndividualIcon';
import type { PageCardInterface } from './PageCard';
import RoleIcon from './RoleIcon';

const entitySummaryCards: PageCardInterface[] = [
  {
    tab: Tab.EntitySummary,
    heading: 'Companies & <br class="landing-break-line"/>Industries',
    description:
      'Track the headcounts, inflows, and outflows of any role at any company or industry to see real time changes in the workforce',
    bgColor: '#F6FAFF',
    hoverBgColor: '#E4F1FF',
    path: '/company/summary',
    icon: <CompanyIcon />,
  },
  {
    tab: Tab.EntitySummary,
    heading: 'Cities & <br class="landing-break-line"/>States',
    description:
      'See the workforce at any city and state to understand changes in compensation and enhance your talent intelligence capabilities',
    bgColor: '#F3FDF7',
    hoverBgColor: '#DDF8E8',
    path: '/geography/summary',
    icon: <GeographyIcon />,
  },
  {
    tab: Tab.EntitySummary,
    heading: 'Jobs & <br class="landing-break-line"/>Skills',
    description:
      'Analyze how technology is impacting the workforce, identify skill gaps, and how the occupational landscape is transforming',
    bgColor: '#F9F6FF',
    hoverBgColor: '#EDE5FF',
    path: '/role/summary',
    icon: <RoleIcon />,
  },
];

const talentDiscoveryCard: PageCardInterface = {
  tab: Tab.TalentDiscovery,
  heading: 'Talent & <br class="landing-break-line"/>Prospects',
  description:
    'Access the most powerful talent discovery tool, allowing anybody to find professionals, to either partner with or recruit',
  bgColor: '#FFF9F7',
  hoverBgColor: '#FFEDE7',
  path: '/talent-discovery',
  icon: <IndividualIcon />,
};

export const getPageCardData = (
  hasEntitySummary: boolean
): PageCardInterface[] => {
  const resolvedEntityCards = hasEntitySummary
    ? entitySummaryCards
    : entitySummaryCards.map((card) => ({
        ...card,
        path: card.path.replace('/summary', '/compositions'),
      }));

  return [...resolvedEntityCards, talentDiscoveryCard];
};
